import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Robusttechstack(props) {
  return (
    <div className="robusttech_stack p-100" style={{ background: "#F5F5F8" }}>
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <div
              className="example dark_bg_text text-center center"
              data-text="التكنولوجيا"
            >
              <h2>TekRevol's Robust Tech Stack</h2>
            </div>
            <p>{props.txt}</p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tab-content">
            <div className="tech_sec_ae">
              <div className="tech_main_ae">
                <div className="tech_box_title">
                  <h5>Front-end</h5>
                </div>
                <div className="tech_box_txt">
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/html.png"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>HTML</span>
                  </div>
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/JavaScript.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>JavaScript</span>
                  </div>
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/React.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>React</span>
                  </div>
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/Angular.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>Angular</span>
                  </div>
                </div>
              </div>
              <div className="tech_main_ae">
                <div className="tech_box_title">
                  <h5>Back-end</h5>
                </div>
                <div className="tech_box_txt">
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/Laravel.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>Laravel</span>
                  </div>
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/Java.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>Java</span>
                  </div>
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/Ruby.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>Ruby</span>
                  </div>
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/C#.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>C#</span>
                  </div>
                </div>
              </div>
              <div className="tech_main_ae">
                <div className="tech_box_title">
                  <h5>Databases</h5>
                </div>
                <div className="tech_box_txt">
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/MySQL.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>MySQL</span>
                  </div>
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/Mongo-DB.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>MongoDB</span>
                  </div>
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/oracle.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>Oracle</span>
                  </div>
                </div>
              </div>
              <div className="tech_main_ae">
                <div className="tech_box_title">
                  <h5>Tools</h5>
                </div>
                <div className="tech_box_txt">
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/Sublime-Tex.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>Sublime Text</span>
                  </div>
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/Visual-Studio-Code.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>Visual Studio Code</span>
                  </div>
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/Atom.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>Atom</span>
                  </div>
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/Code-Pen.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>Code Pen</span>
                  </div>
                </div>
              </div>
              <div className="tech_main_ae">
                <div className="tech_box_title">
                  <h5>Operating</h5>
                </div>
                <div className="tech_box_txt">
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/Windows.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>Windows</span>
                  </div>
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/macOS.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>macOS</span>
                  </div>
                  <div className="txt_box_items">
                    <StaticImage
                      src="../../../images/locationgcc/dxb/ae/Linux.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={40}
                      height={41}
                    />
                    <span>Linux</span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Robusttechstack;
